import Home from "../components/Home/Home.jsx";
import AddPanel from "../components/AddPanel/AddPanel.jsx";
import Providers from "../components/Providers/Providers.jsx";
import PanelsDetails from "../components/Providers/PanelsDetails.jsx";
import OurServices from "../components/OurServices/OurServices.jsx";
import ServicesInvoice from "../components/OurServices/SerivcesInvoice.jsx";
import Login from "../Auth/Login.jsx";
import Signup from "../Auth/Signup.jsx";
import VerifyAccount from "../Auth/VerifyAccount.jsx";
import ForgetPassswordByEmail from "../Auth/ForgetPasswordByEmail.jsx";
import VerficationPasswordByEmail from "../Auth/VerficationPasswordByEmail.jsx";
import ResetPassword from "../Auth/ResetPassword.jsx";
import OurOffers from "../components/Offers/OurOffers.jsx";
import OffersDetails from "../components/Offers/OffersDetails.jsx";
import OffersInvoice from "../components/Offers/OffersInvoice.jsx";
import ProtectedRoute from "../Routes/ProtectedRoutes";
import GuestRoute from "./GuestRoute.js";
import UserApp from "../UserDashbaord/UserApp.js";
import Dashboard from "../UserDashbaord/Pages/Dashboard/Dashbaord.jsx";
import OrderHistory from "../UserDashbaord/Pages/OrderHistory/OrderHistory.jsx";
import Tickets from "../UserDashbaord/Pages/Tickets/Tickets.jsx";
import Services from "../UserDashbaord/Pages/Services/Services.jsx";
import Profile from "../components/Profile/Profile.jsx";
import SearchLog from "../UserDashbaord/Pages/SearchLog/SearchLog.jsx";
import ChangePassword from "../components/Profile/change-password/index.jsx";
import ChangePasswordVerifyCode from "../components/Profile/change-password-verify-code/index.jsx";
import TicketsChat from "../UserDashbaord/Pages/TicketsChat/index.jsx";
import ServiceStatistics from "../UserDashbaord/Pages/OrderHistory/service-statistics/index.jsx";
import MyPanel from "../UserDashbaord/Pages/MyPanel/MyPanel.jsx";
import MyPanelId from "../UserDashbaord/Pages/MyPanelId/MyPanel.jsx";
import MyPanels from "../UserDashbaord/Pages/MyPanels/MyPanels.jsx";
import EditPanel from "../UserDashbaord/Pages/MyPanel/Edit/EditPanel.jsx";
import EditPanelId from "../UserDashbaord/Pages/MyPanelId/Edit/EditPanel.jsx";
import FAQ from "../components/Home/faq/index.jsx";
import AboutUs from "../components/Home/AboutUs/index.jsx";
import PrivacyPolicy from "../components/Home/PrivacyPolicy/PrivacyPolicy.jsx";
import TermsOfUse from "../components/Home/TermsOfUse.jsx/TermsOfUse.jsx";
import ServiceDetails from "../components/Providers/ServiceDetails/Details.jsx";
import Terms from "../components/Terms/Terms.jsx";
import PaymentSuccess from "../components/OurServices/PaymentSuccess";
import PaymentFailed from "../components/OurServices/PaymentFailed";
import ServicesReviews from "../UserDashbaord/Pages/Reviews/Services.jsx";
import PanelsReviews from "../UserDashbaord/Pages/Reviews/Panels.jsx";

import SerivcesInvoiceByGuest from "../components/OurServices/SerivcesInvoiceByGuest";
import OffersInvoiceByGuest from "../components/Offers/OffersInvoiceByGuest";
import WhatsappGroup from "../UserDashbaord/Pages/SocialGroups/Whatsapp";
import TelegramGroup from "../UserDashbaord/Pages/SocialGroups/Telegram";
import SkypeGroup from "../UserDashbaord/Pages/SocialGroups/Skype";
import Memberships from "../UserDashbaord/Pages/Membership/Memberships";
import MembershipDetails from "../UserDashbaord/Pages/Membership/MembershipDetails";
import MembershipSubscribe from "../Auth/MembershipSubscribe";
import MembershipSubscripeWithAccount from "../Auth/MembershipSubscripeWithAccount";
import MembershipInvoice from "../Auth/MembershipInvoice";
import MembershipSubscription from "../UserDashbaord/Pages/Membership/MembershipSubscription";
import AdsPanelsDetails from "../components/Providers/AdsPanelsDetails";
import MembershipUserSubscribe from "../Auth/MembershipUserSubscribe";
import WhatsappGroups from "../components/SocialGroups/WhatsappGroups";
import SkypeGroups from "../components/SocialGroups/SkypeGroups";
import TelegramGroups from "../components/SocialGroups/TelegramGroups";
import Panels from "../components/SocialGroups/Panels";
import AddAdPage from "../components/Ads/AddAd.jsx";
import AdsListing from "../components/Ads/Ads.jsx";
import AdDetailsPage from "../components/Ads/AdDetails.jsx";
import { ChatInterface } from "../components/Ads/ChatInterface.tsx";
import AdsHistory from "../UserDashbaord/Pages/AdsHistory/AdsHistory";
import ResellerProfile from "../components/Resellers/ResellerProfile.jsx";
import AdDetails from "../components/Resellers/AdDetails.jsx";

import OurTeam from "../components/Home/OurTeam/OurTeam";

import ResellerReviews from "../UserDashbaord/Pages/Reviews/Resellers.jsx";
import ResellerAdReviews from "../UserDashbaord/Pages/Reviews/ResellerAd.jsx";
import EditAd from "../UserDashbaord/Pages/AdsHistory/Edit/EditAd";
import AdsStatistics from "../UserDashbaord/Pages/AdsHistory/service-statistics";
import AddGroup from "../components/SocialGroups/Add/AddGroup";
import SmmDomains from "../components/SmmDomains/SmmDomains";
import SmmDomainDetails from "../components/SmmDomains/SmmDomainDetails";
import DomainInvoice from "../components/SmmDomains/DomainInvoice";
import LastMinute from "../components/LastMinute/LastMinute";
import AddLastMinute from "../components/LastMinute/AddLastMinute";
import LastMinutesHistory from "../UserDashbaord/Pages/LastMinutesHistory/LastMinutesHistory";
import DipositHistory from "../UserDashbaord/Pages/DipositHistory/DipositHistory";
import MakeRecharge from "../UserDashbaord/Pages/DipositHistory/MakeRecharge";
import AccountSetting from "../UserDashbaord/Pages/Settings/AccountSetting";
import ServicesEdit from "../components/OurServices/ServicesEdit.jsx";
import OurServicesPackage from "../components/OurServices/OurServicesPackage";
import NotificationList from "../UserDashbaord/Pages/Notification/NotificationList";
import NewOrderHistory from "../UserDashbaord/Pages/OrderHistory/NewOrderHistory";
import OfferDetails from "../UserDashbaord/Pages/OrderHistory/Details/OfferDetails";
import DomainDetails from "../UserDashbaord/Pages/OrderHistory/Details/DomainDetails";
import OrderDetails from "../UserDashbaord/Pages/OrderHistory/Details/OrderDetails";
import ServicesOfferEdit from "../components/OurServices/ServicesOfferEdit";


function createRoute(path, element, isProtected = false, isGuest = false) {
  const Component = isProtected ? (
    <ProtectedRoute>{element}</ProtectedRoute>
  ) : isGuest ? (
    <GuestRoute>{element}</GuestRoute>
  ) : (
    element
  );

  return { path, element: Component, protected: isProtected };
}

const routes = [
  createRoute("/", <Home />, false),
  createRoute("/Home", <Home />, false),
  createRoute("/FAQ", <FAQ />, false),
  createRoute("/AddPanel", <AddPanel />, false),
  createRoute("/AddGroup", <AddGroup />, false),
  // createRoute("/Providers", <Providers />, false),
  createRoute("/PanelsDetails/:paneluuid", <PanelsDetails />, true),
  createRoute("/AdsPanelsDetails/:paneluuid", <AdsPanelsDetails />, false),
  createRoute("/ServiceDetails/:serviceid", <ServiceDetails />, true),
  createRoute("/payment/success", <PaymentSuccess />, true),
  createRoute("/payment/failed", <PaymentFailed />, true),
  createRoute("/OurServices", <OurServices />, false),
  createRoute("/packages", <OurServicesPackage />, false),
  createRoute("/LastMinute", <LastMinute />, false),
  createRoute("/post-last-minute", <AddLastMinute />, true),
  createRoute("/make-recharge", <MakeRecharge />, true),
  createRoute("/WhatsappGroups", <WhatsappGroups />, false),
  createRoute("/Panels", <Panels />, false),
  createRoute("/SkypeGroups", <SkypeGroups />, false),
  createRoute("/TelegramGroups", <TelegramGroups />, false),
  createRoute("/smmDomains", <SmmDomains />, false),
  createRoute("/SmmDomainDetails/:id", <SmmDomainDetails />, false),
  createRoute("/OurServices/:id/:typeId", <OurServices />, false),
  createRoute("/ServicesInvoice", <ServicesInvoice />, true),
  createRoute("/dashboard/ServicesEdit/:id/", <ServicesEdit />, true),
  createRoute("/dashboard/services-offer-edit/:id/", <ServicesOfferEdit />, true),
  createRoute("/DomainInvoice", <DomainInvoice />, true),
  // createRoute("/Invoice", <SerivcesInvoiceByGuest />, false),
  createRoute("/login", <Login />, false, true),
  createRoute("/signup", <Signup />, false, true),
  createRoute("/VerifyAccount", <VerifyAccount />, false, true),
  createRoute("/About", <AboutUs />, false),
  createRoute("/Terms", <Terms />, false),
  createRoute("/PrivacyPolicy", <PrivacyPolicy />, false),
  createRoute("/TermsOfUse", <TermsOfUse />, false),
  createRoute("/Team", <OurTeam />, false),
  // createRoute("/Memberships", <Memberships />, false),
  // createRoute("/Membership/Subscribe/:id", <MembershipSubscribe />, false),
  // createRoute("/Membership/UserSubscribe/:id", <MembershipUserSubscribe />, true),
  // createRoute("/Membership/SubscribeWithAccount/:id", <MembershipSubscripeWithAccount />, false),
  // createRoute("/payMembership", <MembershipInvoice />, true),
  createRoute("/resellers/:id", <ResellerProfile />, false),
  createRoute("/resellers/:id/resellerAd/:Adid", <AdDetails />, false),
  createRoute("dashboard/reviews/resellers", <ResellerReviews />, false),
  createRoute("dashboard/reviews/resellerads", <ResellerAdReviews />, false),
  createRoute(
    "/ForgetPassswordByEmail",
    <ForgetPassswordByEmail />,
    false,
    true
  ),
  createRoute(
    "/VerficationPasswordByEmail",
    <VerficationPasswordByEmail />,
    false,
    true
  ),
  createRoute("/ResetPassword", <ResetPassword />, false),
  // createRoute("/OurOffers", <OurOffers />, false),
  createRoute("/OffersDetails/:offer_id", <OffersDetails />, false),
  createRoute("/OffersInvoice", <OffersInvoice />, true),
  // createRoute("/OfferInvoice", <OffersInvoiceByGuest />, false),
  createRoute("/profile", <Profile />, true),
  createRoute("/profile/change-password", <ChangePassword />, true),
  createRoute("/post-ad", <AddAdPage />, true),
  createRoute("/ads", <AdsListing />, false),
  createRoute("/ads/:id", <AdDetailsPage />, false),
  createRoute("/chats/:type/:id", <ChatInterface />, true),
  createRoute("/chats/:type/:user_type/:id", <ChatInterface />, true),
  createRoute("/chats/:type", <ChatInterface />, true),
  createRoute("/chats", <ChatInterface />, true),
  createRoute(
    "/profile/change-password/verify",
    <ChangePasswordVerifyCode />,
    true
  ),
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <UserApp />
      </ProtectedRoute>
    ),
    children: [
      { path: "overview", element: <Dashboard /> },
      { path: "deposit", element: <DipositHistory /> },
      { path: "order-history", element: <NewOrderHistory /> },
      { path: "order-history/service-details/:id", element: <OrderDetails /> },
      { path: "order-history/offer-details/:id", element: <OfferDetails /> },
      { path: "order-history/domain-details/:id", element: <DomainDetails /> },
      { path: "new-order-history", element: <OrderHistory /> },
      { path: "ads-history", element: <AdsHistory /> },
      { path: "last-minute-history", element: <LastMinutesHistory /> },
      { path: "ad-history/edit/:id", element: <EditAd /> },
      { path: "ad-history/statistic/:id", element: <AdsStatistics /> },
      { path: "mypanel", element: <MyPanel /> },
      { path: "mypanelId/:id", element: <MyPanelId /> },
      { path: "mypanels", element: <MyPanels /> },
      { path: "mypanel/edit", element: <EditPanel /> },
      { path: "mypanel/edit/:id", element: <EditPanelId /> },
      {
        path: "order-history/service-statistic/:id",
        element: <ServiceStatistics />,
      },
      { path: "tickets", element: <Tickets /> },
      { path: "tickets/:id", element: <TicketsChat /> },
      { path: "services", element: <Services /> },
      { path: "searchlog", element: <SearchLog /> },
      { path: "reviews/services", element: <ServicesReviews /> },
      { path: "reviews/panels", element: <PanelsReviews /> },
      { path: "socialGroup/whatsapp", element: <WhatsappGroup /> },
      { path: "socialGroup/skype", element: <SkypeGroup /> },
      { path: "socialGroup/telegram", element: <TelegramGroup /> },
      { path: "notification/setting", element: <AccountSetting /> },
      { path: "notification/list", element: <NotificationList /> },
      { path: "profile", element: <Profile /> },
      // { path: "membership/memberships", element: <Memberships /> },
      // { path: "membership/:id", element: <MembershipDetails /> },
      // { path: "membership/subscription", element: <MembershipSubscription /> },
    ],
  },
];

export default routes;
